import { render } from "./PaymentSuccess.vue?vue&type=template&id=42ebd338&ts=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=ts"
export * from "./PaymentSuccess.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__